var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAC2CB",
  d: "m13.414 12 2.829-2.828a1.001 1.001 0 0 0-1.415-1.415L12 10.586 9.172 7.757a1 1 0 1 0-1.415 1.415L10.586 12l-2.829 2.828a1 1 0 1 0 1.415 1.415L12 13.414l2.828 2.829a1 1 0 1 0 1.415-1.415zM6 2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4"
})));
export { SvgClose as ReactComponent };
export default __webpack_public_path__ + "Close.cea5d4fc.svg";